
import Footer from "../../../../../src/pages/docs/src/Footer.tsx";
import Header from "../defaults/Header.tsx";
import Logo from "../../../../../src/pages/docs/src/Logo.tsx";
import InfoBar from "../defaults/InfoBar.tsx";
import Breadcrumbs from "../defaults/Breadcrumbs.tsx";
import SectionNav from "../defaults/SectionNav.tsx";

const brandName = "Piral";
const languages = [].map(s => ({
  ...s,
  select() {
    location.href = '/' + s.code;
  },
}));

export { Footer, Header, Logo, InfoBar, Breadcrumbs, SectionNav, brandName, languages };
